import { createWidgetScript } from '../common.js';

let products;

function getProducts() {
  const newProducts = [];
  for (const el of document.querySelectorAll('[vw-product-id]')) {
    newProducts.push({ id: el.getAttribute('vw-product-id'), isTag: true });
  }

  const defaulProductUID = window.ShopifyAnalytics?.meta?.product?.id;
  if (defaulProductUID) {
    newProducts.push({ id: defaulProductUID, isTag: false });
  }

  return newProducts.length > 0 ? newProducts : undefined;
}

function updateVariants() {
  // Don't allow updating variants when a static product is selected
  if (products?.length > 0) {
    return;
  }

  const newProduct = window.ShopifyAnalytics.meta.product;
  const searchParams = new URLSearchParams(window.location.search);
  const newVariant = searchParams.get('variant');
  // skipcq JS-0125
  _hw('event', 'set-product', { productUID: `${newProduct.id}`, variant: newVariant });
}

// Update variant on url change
function onUrlChange() {
  updateVariants();
}

/* eslint-disable prefer-destructuring */
function embedWidget() {
  products = getProducts();
  const defaulProductUID = window.ShopifyAnalytics?.meta?.product?.id;

  const variant = window.ShopifyAnalytics?.meta?.product?.id ? window.ShopifyAnalytics?.meta?.selectedVariantId : undefined;
  const hasWidgetEntries = !!document.querySelector('[vw-widget]') || !!document.querySelector('[vw-showcase]');
  const hasQuizEntries = [...document.querySelectorAll('[vw-mode]').values()].filter((el) => el.getAttribute('vw-mode') === 'quiz').length > 0;

  const isCollectionPage = window.ShopifyAnalytics?.meta?.page?.pageType === 'collection';
  const productCollectionUID =
    window.ShopifyAnalytics?.meta?.page?.resourceType === 'collection' ? window.ShopifyAnalytics?.meta?.page?.resourceId : undefined;

  console.debug(`vestico: has widget entries: ${hasWidgetEntries}, product ${JSON.stringify(products)}, plp ${productCollectionUID}`);

  createWidgetScript();

  const shop = window.Shopify.shop;
  const isPreview = window.Shopify.designMode || window.Shopify.PreviewBarInjector !== undefined;
  // skipcq JS-0125
  _hw('init', {
    clientId: shop,
    products: products ? products.map((product) => ({ productUID: `${product.id}`, isTag: product.isTag, variant: variant })) : undefined,
    productCollection: isCollectionPage ? { productCollectionUID: productCollectionUID ? `${productCollectionUID}` : 'all' } : undefined,
    styles: { coreColor: '#303030' },
    isPreview: isPreview,
    isShowcase: true,
    isQuiz: hasQuizEntries && !defaulProductUID && !isCollectionPage,
    language: document.documentElement.lang,
    currencyCode: window.Shopify.currency?.active,
    type: 'shopify',
  });

  // Add observer to detect url change. This will call "onUrlChange()"
  let lastUrl = window.location.href;
  new MutationObserver(() => {
    const url = window.location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      onUrlChange();
    }
  }).observe(document, { subtree: true, childList: true });
}

if (document.readyState === 'loading') {
  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', embedWidget);
} else {
  // `DOMContentLoaded` has already fired
  embedWidget();
}
